import { render, staticRenderFns } from "./userInvite.vue?vue&type=template&id=7a6c0624&scoped=true"
import script from "./userInvite.vue?vue&type=script&lang=js"
export * from "./userInvite.vue?vue&type=script&lang=js"
import style0 from "./userInvite.vue?vue&type=style&index=0&id=7a6c0624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6c0624",
  null
  
)

export default component.exports